export default __webpack_public_path__ + "static/media/Shoe1.08ca85d9.mp4";